// extracted by mini-css-extract-plugin
export var button = "_fv-4";
export var hasDarkBackground = "_fv-7";
export var hasLightBackground = "_fv-6";
export var iconWrapper = "_fv-0";
export var large = "_fv-2";
export var medium = "_fv-1";
export var small = "_fv-5";
export var xsmall = "_fv-3";